import React from 'react'
import Booking from './Booking/Booking'
import RequestCallback from './Booking/RequestCallback'

const CtaSection = () => {
    return (
        <section className='cta_section py-5' id='contact'>
            <div className='row justify-content-center align-items-center py-md-5 mx-0'>
                <div className="col-md-8 col-12 text-center text-white ps-md-0 px-5">
                    <h2 className='display-6 fw-semibold'>
                        Construct with Confidence. Scale with Technology.
                    </h2>
                    <p className='mt-3'>
                        Zithas Technologies brings clarity to complexity—helping construction firms digitise workflows, streamline collaboration, and keep every project moving forward. No guesswork, no delays—just the right tools to build better.
                    </p>
                    <p className='mt-2'>
                        📩 Let’s Talk Tech for Construction – Schedule Your Free Discovery Call.
                    </p>

                    <div className='mt-5'>
                        <RequestCallback btn_text={"Schedule a Discovery Call"} />
                        <Booking />
                    </div>

                    <p className='mt-4'>
                        <strong>Thank You!</strong><br />
                        Thanks for connecting with Zithas Technologies.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default CtaSection